<template>
  <v-card tile>
    <v-card tile color="background">
      <v-card-title class="text-h4 justify-center">Edit Favorites</v-card-title>
    </v-card>

    <v-tabs v-model="tab" centered background-color="background" color="primaryText">
      <v-tabs-slider color="primaryText"></v-tabs-slider>

      <v-tab v-for="icon in icons" :key="icon">
        <v-icon>{{ icon }}</v-icon>
      </v-tab>

      <v-tabs-items v-model="tab" class="bg-card">
        <v-tab-item v-for="medium in mediums" :key="medium">
          <search-tile
            large
            v-on:icon="favoriteIsSet(medium) ? clearFavorite(medium) : null"
            :icon="favoriteIsSet(medium) ? 'mdi-delete' : null"
            :is-set="favoriteIsSet(medium)"
            :medium="medium"
            :title="favorites[medium].title"
            :subtitle="favorites[medium].subtitle"
            :image="favorites[medium].image"
            :key="favorites[medium].id"
          ></search-tile>

          <v-divider></v-divider>

          <search-bar class="mx-10 my-5" v-model="search[medium]"></search-bar>

          <search-results
            :search="search[medium]"
            :medium="medium"
            v-on:click="changeFavorite(medium, $event)"
          ></search-results>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-card>
</template>

<style scoped></style>

<script>
import { mapMutations } from "vuex";
import { getSubtitleFromWork } from "../../util/mediumHelpers";
import { mediums } from "../../util/enums";

export default {
  name: "edit-favorites-drawer",

  data: () => ({
    tab: null,
    favorites: {
      album: {},
      podcast: {},
      film: {},
      book: {},
      tvShow: {},
    },

    search: {
      album: null,
      podcast: null,
      film: null,
      book: null,
      tvShow: null,
    },

    click: null,

    // TODO: Factor out to use helper function to get icon. Order matters in these lists currently
    mediums: [mediums.ALBUM, mediums.PODCAST, mediums.FILM, mediums.BOOK, mediums.TV_SHOW],
    icons: ["mdi-music", "mdi-microphone", "mdi-movie", "mdi-book-open-variant", "mdi-television-classic"],
  }),

  props: {
    data: { type: Object, default: () => ({}) },
  },

  computed: {
    userId() {
      return this.$store.state.userId;
    },
  },

  mounted: function () {
    this.getFavorites();
  },

  methods: {
    ...mapMutations(["closeDrawer", "showSnackbar"]),

    setFavoriteData: function (medium, id, image, title, subtitle) {
      this.favorites[medium] = {
        image: image,
        title: title,
        subtitle: subtitle,
        id: id,
      };
    },

    clearFavorite: async function (medium) {
      await this.$axios.delete(`/v1/users/${this.userId}/favorites/${medium}`);

      this.$root.$emit("update-favorites", medium);

      this.favorites[medium] = {};
    },

    changeFavorite: async function (medium, id) {
      this.favorites[medium].id = id;

      await this.saveFavorites();

      this.getFavorite(medium, id);

      console.log(this.favorites);

      this.$root.$emit("update-favorites", medium);
    },

    saveFavorites: function () {
      let patchObject = {};
      for (const [medium, favorite] of Object.entries(this.favorites)) {
        if (favorite.id) {
          patchObject[medium] = { id: favorite.id.toString() };
        }
      }
      return new Promise((resolve) => {
        this.$axios
          .patch(`/v1/users/${this.userId}/favorites`, patchObject)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            console.error(error);
          });
      });
    },

    getFavorites: function () {
      for (const medium of Object.values(this.$mediums)) {
        if (this.data[medium]) {
          this.getFavorite(medium, this.data[medium]);
        }
      }
    },

    getFavorite: async function (medium, id) {
      try {
        const workDetailsResponse = await this.$axios.get(`/v1/works/${medium}/${id}`);
        const subtitle = getSubtitleFromWork(workDetailsResponse.data);
        this.setFavoriteData(
          medium,
          id,
          workDetailsResponse.data.posterSource,
          workDetailsResponse.data.title,
          subtitle,
        );
      } catch (err) {
        console.error(err);
        this.showSnackbar({
          text: "An Error occurred",
          error: true,
        });
        this.setFavoriteData(medium);
      }
    },

    favoriteIsSet(medium) {
      return !!this.favorites[medium].title;
    },
  },
};
</script>
